// extracted by mini-css-extract-plugin
export default {"container":"Dashboard-module--container--KTqAX","cards":"Dashboard-module--cards--dmONI","cardsmobile":"Dashboard-module--cardsmobile--NGN7g"};